import * as React from 'react';

import { useNavigationGuard } from 'next-navigation-guard';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { ButtonPrimary, ButtonTextSecondary } from '../core/button';
import { NavigationGuardProps } from './types';

export const NavigationGuard = ({
  customMessage,
  enabled: propEnabled,
  formHasBeenEdited,
  isDirty,
  isSubmitSuccessful,
  isSubmitting,
}: NavigationGuardProps) => {
  const navGuardEnabled =
    (propEnabled ?? true) && isDirty && formHasBeenEdited && !isSubmitting && !isSubmitSuccessful;
  const navGuard = useNavigationGuard({
    enabled: navGuardEnabled,
  });
  const guardMessage = customMessage ?? 'You have unsaved changes that will be lost.';
  return (
    <Dialog
      aria-describedby="navigation-guard-dialog-description"
      aria-labelledby="navigation-guard-dialog-title"
      onClose={navGuard.reject}
      open={navGuard.active}
    >
      <DialogTitle id="navigation-guard-dialog-title">Unsaved Changes</DialogTitle>
      <DialogContent>
        <DialogContentText id="navigation-guard-dialog-description">
          {guardMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ButtonTextSecondary autoFocus onClick={navGuard.reject}>
          Cancel
        </ButtonTextSecondary>
        <ButtonPrimary onClick={navGuard.accept}>Discard</ButtonPrimary>
      </DialogActions>
    </Dialog>
  );
};
